import CouponError from './CouponsError';
class CouponExpired extends CouponError {
    couponId;
    propertyId;
    constructor(couponId, propertyId, options) {
        super('The Promotional Coupon expiration date already passed', options);
        this.couponId = couponId;
        this.propertyId = propertyId;
    }
}
export default CouponExpired;
